import {WithSummaryModel} from '../../../../common/entity/dto/plain/withSummary.model';
import {ReportSummaryModel} from './reportSummary.model';
import {ReportRecipientModel} from './reportRecipient.model';
import {ReportCommunicationContentModel} from './reportCommunicationContent.model';
import {DocumentSummaryModel} from '../../../../document/common/api/model/documentSummary.model';

export class ReportModel extends WithSummaryModel<ReportSummaryModel> {
    recipients: ReportRecipientModel[] = [];
    contents: ReportCommunicationContentModel[] = [];
    content: string;
    documents: DocumentSummaryModel[] = [];

    canBeSentByEmail(): boolean {
        return this.recipients.filter(value => value.sendByEmail === true).length > 0;
    }
}
